module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "forecast-checkbox",
    attrs: {
      "v-model": _vm.localValue,
      "id": _vm.forecastId,
      "type": "checkbox"
    },
    on: {
      "change": function (e) { return _vm.$emit('updateValue', e.target.checked); }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.forecastId
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62cb5732","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/form/CheckBoxTable.vue
// module id = 3226
// module chunks = 0